/**
 * CDN Assets Configuration
 * Медиа-файлы лендинга загружаются с CloudFront CDN
 * 
 * Для обновления файлов:
 * 1. Загрузите новые файлы на S3: node scripts/upload-landing-assets.js
 * 2. Файлы автоматически доступны по тем же URL
 */

// CloudFront custom domain (media.starproai.com) попадает под SNI-фильтрацию
// у российских провайдеров — картинки и видео грузятся мучительно медленно.
// Дефолтный CloudFront-домен (*.cloudfront.net) не фильтруется.
// Для `.ru` доменов на лету переключаемся на дефолтный, инфра та же.
const CDN_PRIMARY_DOMAIN = 'https://media.starproai.com';
const CDN_RU_FALLBACK_DOMAIN = 'https://d2i5ngpuayeib2.cloudfront.net';

export function getCdnBaseUrl(): string {
  if (typeof window === 'undefined') return CDN_PRIMARY_DOMAIN;
  return window.location.hostname.toLowerCase().endsWith('.ru')
    ? CDN_RU_FALLBACK_DOMAIN
    : CDN_PRIMARY_DOMAIN;
}

export const CDN_BASE_URL = getCdnBaseUrl();
const LANDING_ASSETS_PATH = 'landing-assets';

/**
 * Получить URL для ассета на CDN
 */
export function getCdnUrl(path: string): string {
  return `${CDN_BASE_URL}/${LANDING_ASSETS_PATH}/${path}`;
}

/**
 * Видео файлы лендинга
 */
export const LandingVideos = {
  // Hero section
  heroVideo: getCdnUrl('videos/hero_video.mp4'),
  
  // Avatar section
  avatarRU: getCdnUrl('videos/Avatar_RU.mp4'),
  avatarEN: getCdnUrl('videos/Avatar_EN.mp4'),
  avatarHero: getCdnUrl('videos/Avatar/Avatar.mp4'),
  
  // Image editing examples
  duckVideo: getCdnUrl('videos/Duck_video.mp4'),
  catVideo: getCdnUrl('videos/Cat_paw_video.mp4'),
  
  // Video editing
  videoEdit: getCdnUrl('videos/Video_edit_01.mp4'),
  featureVideoClip: getCdnUrl('videos/page10-new.mp4'),
  
  // Image editing
  imageEditVideo: getCdnUrl('videos/image_edit_01.mp4'),
  
  // Login page
  loginVideo: getCdnUrl('videos/video_01_2.mp4'),
} as const;

/**
 * Изображения лендинга (WebP format для 96.5% меньшего размера)
 */
export const LandingImages = {
  // Product section
  productPhoto: getCdnUrl('images/product_photo.webp'),
  productPhoto02: getCdnUrl('images/product_photo_02.webp'),
  productPhoto03: getCdnUrl('images/product_photo_03.webp'),
  productBackground: getCdnUrl('images/product_background.webp'),
  productUpscale: getCdnUrl('images/product_upscale.webp'),
  
  // Design section
  designSketch: getCdnUrl('images/design_sketch.webp'),
  designStyle: getCdnUrl('images/design_style.webp'),
  designCovers: getCdnUrl('images/design_covers.webp'),
  
  // Feature cards
  featureChat: getCdnUrl('images/feature_chat.webp'),
  featureImage: getCdnUrl('images/feature_image.webp'),
  
  // Avatar guide
  girl01: getCdnUrl('images/Girl_01.webp'),
  
  // Video production photos
  duckPhoto: getCdnUrl('images/Duck_photo.webp'),
  catPhoto: getCdnUrl('images/Cat_paw_photo.webp'),

  // Visionary Studio hero
  visionaryHero: getCdnUrl('images/vision/vision.jpg'),

  // Z-Image showcase
  zImagePhoto01: getCdnUrl('images/Z-Image/z_image_01.webp'),

  // Midjourney showcase
  midjPhoto01: getCdnUrl('images/Midjourney/Midj_Photo_01.webp'),
  midjPhoto02: getCdnUrl('images/Midjourney/Midj_Photo_02.webp'),
  midjPhoto03: getCdnUrl('images/Midjourney/Midj_Photo_03.webp'),

  // Nano Banana showcase
  nanoBananaPhoto01: getCdnUrl('images/Nano Banana/Nano_B_01.webp'),
  nanoBananaPhoto02: getCdnUrl('images/Nano Banana/Nano_B_02.webp'),

  // ChatGPT showcase
  chatGptPhoto01: getCdnUrl('images/Chat GPT/Chat_img_01.webp'),
  chatGptPhoto03: getCdnUrl('images/Chat GPT/Chat_img_03.webp'),

  // Seedream showcase
  seedreamPhoto01: getCdnUrl('images/ByteDance/Seedream_01.webp'),
  seedreamPhoto02: getCdnUrl('images/ByteDance/Seedream_02.webp'),
  seedreamPhoto03: getCdnUrl('images/ByteDance/Seedream_03.webp'),

  // Higgsfield showcase
  higgsfieldPhoto01: getCdnUrl('images/Higgsfield/Soul_01.webp'),
  higgsfieldPhoto02: getCdnUrl('images/Higgsfield/Soul_02.webp'),
  higgsfieldPhoto03: getCdnUrl('images/Higgsfield/Soul_03.webp'),
  higgsfieldPhoto04: getCdnUrl('images/Higgsfield/Soul_04.webp'),

  // Flux showcase
  fluxPhoto01: getCdnUrl('images/Flux/Flux_01.webp'),
  fluxPhoto02: getCdnUrl('images/Flux/Flux_02.webp'),
  fluxPhoto03: getCdnUrl('images/Flux/Flux_03.webp'),
  fluxPhoto04: getCdnUrl('images/Flux/Flux_04.webp'),

  // Recraft showcase
  recraftPhoto01: getCdnUrl('images/Recraft/Recraft_01.webp'),
  recraftPhoto02: getCdnUrl('images/Recraft/Recraft_02.webp'),
  recraftPhoto03: getCdnUrl('images/Recraft/Recraft_03.webp'),
  recraftPhoto04: getCdnUrl('images/Recraft/Recraft_04.webp'),
  recraftPhoto05: getCdnUrl('images/Recraft/Recraft_05.webp'),

  // Runway showcase
  runwayPhoto01: getCdnUrl('images/Runway/Runway_01.webp'),
  runwayPhoto02: getCdnUrl('images/Runway/Runway_02.webp'),

  // Design covers
  designCoversV2: getCdnUrl('images/design_covers.webp'),

  // Reve showcase
  revePhoto01: getCdnUrl('images/Reve/Reve_01.webp'),

  // GPT Image 2 banner mosaic
  gptImage2_01: getCdnUrl('images/New_Model/GPT_Image_01.webp'),
  gptImage2_02: getCdnUrl('images/New_Model/GPT_Image_15.webp'),
  gptImage2_03: getCdnUrl('images/New_Model/GPT_Image_03.webp'),
  gptImage2_04: getCdnUrl('images/New_Model/GPT_Image_04.webp'),
  gptImage2_05: getCdnUrl('images/New_Model/GPT_Image_05.webp'),
  gptImage2_06: getCdnUrl('images/New_Model/GPT_Image_06.webp'),
  gptImage2_07: getCdnUrl('images/New_Model/GPT_Image_07.webp'),
  gptImage2_08: getCdnUrl('images/New_Model/GPT_Image_08.webp'),
  gptImage2_09: getCdnUrl('images/New_Model/GPT_Image_09.webp'),
  gptImage2_10: getCdnUrl('images/New_Model/GPT_Image_10.webp'),
  gptImage2_11: getCdnUrl('images/New_Model/GPT_Image_11.webp'),
  gptImage2_12: getCdnUrl('images/New_Model/GPT_Image_12.webp'),
  gptImage2_13: getCdnUrl('images/New_Model/GPT_Image_13.webp'),

  // Seedance 2.0 banner mosaic
  seedance2_01: getCdnUrl('images/New_Model_Seedance/Seedance_01.webp'),
  seedance2_02: getCdnUrl('images/New_Model_Seedance/Seedance_02.webp'),
  seedance2_03: getCdnUrl('images/New_Model_Seedance/Seedance_03.webp'),
  seedance2_04: getCdnUrl('images/New_Model_Seedance/Seedance_04.webp'),
  seedance2_05: getCdnUrl('images/New_Model_Seedance/Seedance_05.webp'),
  seedance2_06: getCdnUrl('images/New_Model_Seedance/Seedance_06.webp'),
  seedance2_07: getCdnUrl('images/New_Model_Seedance/Seedance_07.webp'),
  seedance2_08: getCdnUrl('images/New_Model_Seedance/Seedance_08.webp'),
  seedance2_09: getCdnUrl('images/New_Model_Seedance/Seedance_09.webp'),
  seedance2_10: getCdnUrl('images/New_Model_Seedance/Seedance_10.webp'),
} as const;

/**
 * Motion Control ассеты (примеры для гайда)
 */
export const MotionControlAssets = {
  // Example 1
  example1Photo: `${CDN_BASE_URL}/admin/Motion_control/1_Ref_photo.png`,
  example1Video: `${CDN_BASE_URL}/admin/Motion_control/1_Ref_video.mp4`,
  example1Out: `${CDN_BASE_URL}/admin/Motion_control/1_Out.mp4`,
  
  // Example 2
  example2Photo: `${CDN_BASE_URL}/admin/Motion_control/2_ref_photo.png`,
  example2Video: `${CDN_BASE_URL}/admin/Motion_control/2_Ref_video.mp4`,
  example2Out: `${CDN_BASE_URL}/admin/Motion_control/2_out.mp4`,
  
  // Example 3
  example3Photo: `${CDN_BASE_URL}/admin/Motion_control/3_ref_photo.png`,
  example3Video: `${CDN_BASE_URL}/admin/Motion_control/3_ref_video.mp4`,
  example3Out: `${CDN_BASE_URL}/admin/Motion_control/3_out.mp4`,
  
  // Preview for Landing page card (using example 2 out)
  preview: `${CDN_BASE_URL}/admin/Motion_control/2_out.mp4`,
} as const;

/**
 * Онборд-видео (день/ночь)
 */
export const OnboardVideos = {
  light: getCdnUrl('images/unboard/Light_theme.mp4'),
  night: getCdnUrl('images/unboard/Night_theme.mp4'),
} as const;

export default {
  CDN_BASE_URL,
  LANDING_ASSETS_PATH,
  getCdnUrl,
  LandingVideos,
  LandingImages,
  MotionControlAssets,
  OnboardVideos,
};

